module.exports = __webpack_public_path__ + "static/media/Posenet model.f49f8d43.png";